"use client"
import {
  Airy
} from "./chunk-ANTTICWY.mjs";

// src/components/rotate.ts
import { mergeStyle } from "@yamada-ui/core";
var Rotate = mergeStyle(Airy)();

export {
  Rotate
};
//# sourceMappingURL=chunk-CLZQ7JHA.mjs.map